<template lang="pug">
  div.message-toast(:class="{ active: toast.show }")
    p.error(v-for="error in toast.errors") {{ message(error) }}
    p(v-for="info in toast.infos") {{ message(info) }}
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        toast: state => state.common.toast,
      }),
    },
    methods: {
      message (data) {
        return (data && data.message) || data
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/MessageToast.vue